import React, { useEffect, useState } from 'react';
import {
  Alert, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography,
} from '@mui/material';
import { ordersAPI } from '../../Api';

export default function PlatformApiStatusDialog({ open, onClose, orderId }) {
  const [attempt, setAttempt] = useState(0);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [copyMessage, setCopyMessage] = useState('');

  useEffect(() => {
    if (!open || !orderId) return undefined;
    const controller = new AbortController();
    let active = true;
    setLoading(true);
    setResult(null);
    setError('');
    setCopyMessage('');
    ordersAPI.checkPlatformApiStatusFromPanel(orderId, { signal: controller.signal })
      .then(({ data }) => {
        if (!active) return;
        if (!data?.success || !Object.prototype.hasOwnProperty.call(data.data || {}, 'response')) {
          setError(data?.data?.message || 'Не удалось получить ответ PlatformAPI');
          return;
        }
        setResult(data.data);
      })
      .catch(err => {
        if (active) setError(err.response?.data?.data?.message || 'Не удалось получить ответ PlatformAPI');
      })
      .finally(() => { if (active) setLoading(false); });
    return () => {
      active = false;
      controller.abort();
    };
  }, [open, orderId, attempt]);

  const json = result ? JSON.stringify(result.response, null, 2) : '';
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(json);
      setCopyMessage('JSON скопирован');
    } catch (_) {
      setCopyMessage('Не удалось скопировать. Выделите JSON и скопируйте вручную.');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth aria-labelledby="platformapi-status-title">
      <DialogTitle id="platformapi-status-title">Ответ PlatformAPI</DialogTitle>
      <DialogContent dividers>
        {loading && <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <CircularProgress size={24} /><Typography>Запрашиваем статус ордера…</Typography>
        </Box>}
        {error && <Alert severity="error">{error}</Alert>}
        {result && <>
          <Typography variant="body2" sx={{ mb: 1, overflowWrap: 'anywhere' }}>
            Payment ID: {result.paymentId} · HTTP {result.httpStatus}
          </Typography>
          {(result.httpStatus < 200 || result.httpStatus >= 300) && (
            <Alert severity="warning" sx={{ mb: 1 }}>Процессинг вернул HTTP {result.httpStatus}. Полный ответ ниже.</Alert>
          )}
          <Box component="pre" aria-label="JSON ответа PlatformAPI" sx={{
            m: 0, p: 2, bgcolor: 'action.hover', borderRadius: 1,
            whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', maxHeight: '60vh', overflow: 'auto',
          }}>{json}</Box>
        </>}
        {copyMessage && <Typography role="status" sx={{ mt: 1 }}>{copyMessage}</Typography>}
      </DialogContent>
      <DialogActions>
        <Button onClick={copy} disabled={!result || loading}>Скопировать JSON</Button>
        <Button onClick={() => setAttempt(value => value + 1)} disabled={loading}>Обновить</Button>
        <Button onClick={onClose}>Закрыть</Button>
      </DialogActions>
    </Dialog>
  );
}
